import { DirectiveBinding, ObjectDirective } from "vue";
import { useModalStore } from "@/store/modal.ts";

const vModal: ObjectDirective = {
  beforeMount(el: Element, binding: DirectiveBinding) {
    let target = binding.value;

    if (Object.keys(binding.modifiers).length > 0) {
      [target] = Object.keys(binding.modifiers);
    }

    el.addEventListener("click", (e) => {
      e.preventDefault();
      useModalStore().showModal({ id: target });
    });
  },
};

export default vModal;
